export const SWITCHBOARD_OPTIMISM_MAINNET_CONFIG = {
    chain: "optimism",
    chainId: 10,
    networkName: "Mainnet",
    address: "",
    sbPushOracle: "",
    metadata: {
        defaultRpcUrl: "https://mainnet.optimism.io",
        defaultExplorer: "https://explorer.optimism.io",
    },
    queues: [],
    attestationQueues: [
        {
            name: "SwitchboardLabs Attestation Queue",
            address: "",
        },
    ],
};
export const SWITCHBOARD_OPTIMISM_TESTNET_CONFIG = {
    chain: "optimism",
    chainId: 420,
    networkName: "Goerli",
    address: "0x7d05d5745499D8cc68FA4Eb5dbd45df53E9c3f1f",
    sbPushOracle: "0xc9d804F1e904cA0912D46E0C02600f75563A4988",
    metadata: {
        defaultRpcUrl: "https://goerli.optimism.io",
        defaultExplorer: "https://goerli-explorer.optimism.io",
    },
    queues: [],
    attestationQueues: [
        {
            name: "SwitchboardLabs Attestation Queue",
            address: "0x455c706AF00af9fCFDA04746Be34c3051aAAD1d4",
        },
    ],
};
/**
@defaultValue the default Optimism configuration

```json
{
  "mainnet": {
    "chain": "optimism",
    "chainId": 10,
    "networkName": "Mainnet",
    "address": "",
    "sbPushOracle": "",
    "metadata": {
      "defaultRpcUrl": "https://mainnet.optimism.io",
      "defaultExplorer": "https://explorer.optimism.io"
    },
    "queues": [],
    "attestationQueues": [
      {
        "name": "SwitchboardLabs Attestation Queue",
        "address": ""
      }
    ]
  },
  "testnet": {
    "chain": "optimism",
    "chainId": 420,
    "networkName": "Goerli",
    "address": "0x7d05d5745499D8cc68FA4Eb5dbd45df53E9c3f1f",
    "sbPushOracle": "0xc9d804F1e904cA0912D46E0C02600f75563A4988",
    "metadata": {
      "defaultRpcUrl": "https://goerli.optimism.io",
      "defaultExplorer": "https://goerli-explorer.optimism.io"
    },
    "queues": [],
    "attestationQueues": [
      {
        "name": "SwitchboardLabs Attestation Queue",
        "address": "0x455c706AF00af9fCFDA04746Be34c3051aAAD1d4"
      }
    ]
  }
}
```
 */
export const SWITCHBOARD_OPTIMISM_CONFIG = {
    mainnet: SWITCHBOARD_OPTIMISM_MAINNET_CONFIG,
    testnet: SWITCHBOARD_OPTIMISM_TESTNET_CONFIG,
};
//# sourceMappingURL=data:application/json;base64,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